import { supabase } from '@/lib/supabase/client';
import type { Json } from '@/lib/supabase/types';

export type PageContentBlock = {
  id: string;
  page_slug: string;
  block_key: string;
  content: Record<string, unknown>;
  updated_at: string;
  updated_by: string | null;
};

export async function getPageContent(pageSlug: string): Promise<PageContentBlock[]> {
  const { data, error } = await supabase
    .from('page_content')
    .select('id, page_slug, block_key, content, updated_at, updated_by')
    .eq('page_slug', pageSlug);

  if (error) throw error;
  return (data ?? []) as PageContentBlock[];
}

export async function upsertPageContentBlock(
  pageSlug: string,
  blockKey: string,
  content: Record<string, unknown>,
  updatedBy: string,
): Promise<void> {
  const { error } = await supabase
    .from('page_content')
    .upsert(
      { page_slug: pageSlug, block_key: blockKey, content: content as Json, updated_by: updatedBy, updated_at: new Date().toISOString() },
      { onConflict: 'page_slug,block_key' },
    );

  if (error) throw error;
}
